<div fxLayout="row" class="icon-title">
  <img alt="icon" [src]="iconPath" />
  <h5>{{ title }}</h5>
</div>
